// ...existing code...
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { URLS } from "./_config";
import RodeoDetailsListing from "./containers/rodeo-details-listing/RodeoDetailsListingContainer";
import LeaderboardListing from "./containers/leaderboard-listing/LeaderboardListingContainer";
// import requireNoAuth from "./_common/hoc/reqNoAuth";
import requireAuth from "./_common/hoc/reqAuth";
import reqLayout from "./_common/hoc/layout";
// import RodeoEventContainer from "./containers/rodeoEvent/rodeoEvent";
// import RodeoGameContainer from "./containers/RodeoGame/rodeoGame";
import Page404 from "./containers/page-404";
import CacheBuster from "./CacheBuster";
import CmsContainer from "./containers/cms";
// import Groups from "./containers/event/groups";
// ...existing code...
import PerformanceLanding from "./containers/performance-landing/PerformanceLandingContainer";
// import RodeoEvents from "./containers/event/rodeo-events";
// import PastRodeoEvents from "./containers/event/past-rodeo-events";
// import UpcomingEvents from "./containers/event/upcomingEvents";
// import Performances from "./containers/event/performances";
// import Login from "./containers/auth/login";
// import LoginWithEmail from "./containers/auth/loginWithEmail";
// import Register from "./containers/auth/register";
// import ForgotPassword from "./containers/auth/forgot-password";
// import ResetPassword from "./containers/auth/reset-password";
import MyProfile from "./containers/auth/myProfile";
// import Prizes from "./containers/event/prizes";
// import PrizeDetails from "./containers/event/prize-details";
// import Riders from "./containers/event/riders";
// import Events from "./containers/event/events";
// import MostPopularPicks from "./containers/event/mostPopularPicks";
// import MyTeam from "./containers/event/myTeam";
// import WinningTicket from "./containers/event/winningTicket";
// import TeamImage from "./containers/event/teamImage";
// import GroupLeaderboard from "./containers/event/rodeoLeaderBoard/group-specific";
// import RodeoEventLeaderBoard from "./containers/event/rodeoLeaderBoard/rodeo-event-specific";
// import EventLeaderBoard from "./containers/event/rodeoLeaderBoard/event-specific";
// import LeagueLeaderboard from "./containers/event/league-leaderboard";
// import TvImage from "./containers/tv-image";
// import GroupTvImage from "./containers/group-tv-image";

function App() {
  return (
    <CacheBuster>
      {({
        loading,
        isLatestVersion,
        refreshCacheAndReload,
      }: {
        loading: boolean;
        isLatestVersion: boolean;
        refreshCacheAndReload: () => void;
      }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (
          <React.Fragment>
            <Router>
              <Switch>
                {/* <Route exact path={URLS.HOME} component={() => <Redirect to={URLS.EVENT.GROUPS} />} /> */}
                {/* <Route exact path={URLS.HOME} component={Landing} /> */}
                <Route exact path={URLS.HOME} component={PerformanceLanding} />
                <Route exact path={URLS.EVENT.RODEO_DETAILS_LISTING} component={RodeoDetailsListing} />
                <Route exact path={URLS.EVENT.LEADERBOARD} component={reqLayout(LeaderboardListing)} />

                {/* Event Routes */}
                {/* <Route exact path={URLS.EVENT.GROUPS} component={Groups} />
                <Route exact path={URLS.EVENT.RODEO_EVENTS} component={RodeoEvents} />
                <Route exact path={URLS.EVENT.PAST_RODEO_EVENTS} component={PastRodeoEvents} />
                <Route exact path={URLS.EVENT.UPCOMING_EVENTS} component={UpcomingEvents} />
                <Route exact path={URLS.EVENT.PERFORMANCES} component={Performances} />
                <Route exact path={URLS.EVENT.PRIZES} component={Prizes} />
                <Route exact path={URLS.EVENT.PRIZE_DETAILS} component={PrizeDetails} />
                <Route exact path={URLS.EVENT.EVENTS} component={Events} />
                <Route exact path={URLS.EVENT.RIDERS} component={Riders} />
                <Route exact path={URLS.EVENT.MOST_POPULAR_PICKS} component={MostPopularPicks} />
                <Route exact path={URLS.EVENT.MY_TEAM} component={MyTeam} />
                <Route exact path={URLS.EVENT.WINNING_TICKET} component={requireAuth(WinningTicket)} />
                <Route exact path={URLS.EVENT.TEAM_IMAGE} component={TeamImage} />
                <Route exact path={URLS.EVENT.LEADER_BOARD.GROUP} component={GroupLeaderboard} />
                <Route exact path={URLS.EVENT.LEADER_BOARD.RODEO_EVENT} component={RodeoEventLeaderBoard} />
                <Route exact path={URLS.EVENT.LEAGUE} component={LeagueLeaderboard} />
                <Route exact path={URLS.EVENT.VS_LEAGUE} component={LeagueLeaderboard} />
                <Route exact path={URLS.EVENT.TV_IMAGE} component={TvImage} />
                <Route exact path={URLS.EVENT.GROUP_TV_IMAGE} component={GroupTvImage} /> */}

                {/* Auth Routes */}
                {/* <Route exact path={URLS.AUTH.LOGIN} component={requireNoAuth(Login)} />
                <Route exact path={URLS.AUTH.LOGIN_WITH_EMAIL} component={requireNoAuth(LoginWithEmail)} />
                <Route exact path={URLS.AUTH.REGISTRATION} component={requireNoAuth(Register)} />
                <Route exact path={URLS.AUTH.FORGOT_PASSWORD} component={requireNoAuth(ForgotPassword)} />
                <Route exact path={URLS.AUTH.RESET_PASSWORD} component={requireNoAuth(ResetPassword)} /> */}
                <Route exact path={URLS.AUTH.MY_PROFILE} component={requireAuth(MyProfile)} />

                {/* CMS Routes */}
                <Route exact path={URLS.CMS.CMS} component={CmsContainer} />
                {/* <Route exact path={URLS.CMS.GAME_CMS} component={CmsContainer} /> */}

                <Route path="*" component={reqLayout(Page404)} />
              </Switch>
            </Router>
          </React.Fragment>
        );
      }}
    </CacheBuster>
  );
}

export default App;
